export enum FileServer  {
    NetpApp = 'nacv',
    None = 'none',
    WindowFileServer = 'dfs'
  }
